import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { MatDialogRef } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { UmsService } from '../ums.service';
import { ModalpopService } from '../modalpop.service';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';

@Component({
  selector: 'app-assign-panel-date',
  templateUrl: './assign-panel-date.component.html',
  styleUrls: ['./assign-panel-date.component.scss']
})
export class AssignPanelDateComponent implements OnInit {
  AssignPanelForm: FormGroup;
  dialogRef: MatDialogRef<any>;

  sessionList: any[] = [];
  sessionFilterList: any[] = [];
  courseList: any[] = [];
  courseFilterList: any[] = [];
  examList: any[] = [];
  examFilterList: any[] = [];
  branchList: any[] = [];
  branchFilterList: any[] = [];
  collegeList: any[] = [];
  centerFilterList: any[] = [];
  subjectList: any[] = [];
  subjectFilterList: any[] = [];
  teacherTooltips: string[] = []; 
  teacherDetailsList: any[][] = []; 

  showBranch = false;
  showTable = false;
  showSaveBtn = true;
  showUpdateBtn = false;
  isBtnDisabled = false;

  holidayDates: { FromDate: Date, ToDate: Date, HolidayName: string }[] = [];
  currentDate = new Date();
  selectedExam: any;
  rowMinDates: Date[] = [];
  rowMaxDates: Date[] = [];

  constructor(
    private fb: FormBuilder,
    private datePipe: DatePipe,
    private spinner: NgxSpinnerService,
    private umsService: UmsService,
    private modalPopupService: ModalpopService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.initForm();
    this.fetchSessions();
    this.fetchHolidays();
  }

  initForm() {
    this.AssignPanelForm = this.fb.group({
      SessionId: new FormControl('', Validators.required),
      CoCode: new FormControl('', Validators.required),
      EmId: new FormControl('', Validators.required),
      strId: new FormControl(''),
      CgCode: new FormControl('', Validators.required),
      EsId: new FormControl('', Validators.required),
      panelArray: new FormArray([])
    });
  }

  getPanelArrayControls() {
    return (this.AssignPanelForm.get('panelArray') as FormArray).controls;
  }

  fetchSessions() {
    this.spinner.show();
    this.umsService.getSession({ SnDefault: '', SnNo: '' }).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.sessionList = res.data.filter(s => s.SnStatus === 'O');
        this.sessionFilterList = [...this.sessionList];
      } else {
        this.sessionList = [];
        this.sessionFilterList = [];
      }
    }, () => this.spinner.hide());
  }

  onSessionChange(session: any) {
    this.resetFormAfterSession();
    this.fetchCourses();
  }

  fetchCourses() {
    this.spinner.show();
    this.umsService.getCourse({}).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.courseList = res.data;
        this.courseFilterList = [...this.courseList];
      } else {
        this.courseList = [];
        this.courseFilterList = [];
      }
    }, () => this.spinner.hide());
  }

  onCourseChange(course: any) {
    this.AssignPanelForm.patchValue({ CoCode: course.CoCode, EmId: '', strId: '', CgCode: '', EsId: '' });
    this.clearExamAndCenter();
    this.fetchExams(course.CoCode);
  }

  fetchExams(coCode: string) {
    this.spinner.show();
    this.umsService.getExam({ EmCoCode: coCode }).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.examList = res.data;
        this.examFilterList = [...this.examList];
      } else {
        this.examList = [];
        this.examFilterList = [];
      }
    }, () => this.spinner.hide());
  }

  onExamChange(exam: any) {
    this.selectedExam = exam;
    this.AssignPanelForm.patchValue({ EmId: exam.EmId, strId: '', CgCode: '', EsId: '' });
    this.clearBranchAndCenter();
    this.subjectList = [];
    this.subjectFilterList = [];

    if (exam.EmStreams === 'Y') {
      this.showBranch = true;
      this.fetchBranches(exam.EmId);
    } else {
      this.showBranch = false;
      this.fetchCenters();
      this.fetchSubjects(0);
    }
  }

  fetchBranches(emId: string) {
    this.spinner.show();
    this.umsService.getExamStream({ EmId: emId }).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.branchList = res.data;
        this.branchFilterList = [...this.branchList];
      } else {
        this.branchList = [];
        this.branchFilterList = [];
      }
    }, () => this.spinner.hide());
  }

  onBranchChange(branch: any) {
    this.AssignPanelForm.patchValue({ strId: branch.StrId, EsId: '' });
    this.fetchCenters();
    this.fetchSubjects(branch.StrId);
  }

  fetchCenters() {
    this.spinner.show();
    const payload = { CoCode: this.AssignPanelForm.value.CoCode };
    this.umsService.fetchstucourseClgMap(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.collegeList = res.data;
        this.centerFilterList = [...this.collegeList];
      } else {
        this.collegeList = [];
        this.centerFilterList = [];
      }
    }, () => this.spinner.hide());
  }

  onCenterChange(center: any) {
    this.AssignPanelForm.patchValue({ CgCode: center.CgCode });
  }

  fetchSubjects(strId: number) {
    this.spinner.show();
    const payload = {
      EsEmId: this.AssignPanelForm.value.EmId,
      EsStrId: strId
    };
    this.umsService.getExamSubMapFetch(payload).subscribe(res => {
      this.spinner.hide();
      this.subjectList = [];
      if (res.status && res.data.children) {
        res.data.children.forEach(element => {
          if (element.EsType === 'S') {
            this.subjectList.push(element);
          } else if (element.EsType === 'G') {
            element.children.forEach(grpSub => {
              this.subjectList.push(grpSub);
            });
          }
        });
        this.subjectFilterList = [...this.subjectList];
      } else {
        this.subjectList = [];
        this.subjectFilterList = [];
      }
    }, () => {
      this.spinner.hide();
      this.subjectList = [];
      this.subjectFilterList = [];
    });
  }

  onSubjectChange(subject: any) {
    this.AssignPanelForm.patchValue({ EsId: subject.EsId });
    this.onShowData();
  }


  onShowData() {
    if (this.AssignPanelForm.invalid) {
      this.AssignPanelForm.markAllAsTouched();
      return;
    }
    this.spinner.show();
    const payload = {
      SessionNo: this.AssignPanelForm.value.SessionId,
      CoCode: this.AssignPanelForm.value.CoCode,
      EmId: this.AssignPanelForm.value.EmId,
      CgCode: this.AssignPanelForm.value.CgCode,
      EsId: this.AssignPanelForm.value.EsId
    };
    this.umsService.getPanelAssignments(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status && res.data.length) {
        this.populatePanelArray(res.data);
        this.showTable = true;
        const hasExisting = this.checkExistingRows();
        if (hasExisting) {
          this.showSaveBtn = false;
          this.showUpdateBtn = true;
        } else {
          this.showSaveBtn = true;
          this.showUpdateBtn = false;
        }
      } else {
        this.showTable = false;
        this.showSaveBtn = true;
        this.showUpdateBtn = false;
        let data = {};
        data['message'] = 'No panel data found for the selected criteria';
        data['title'] = 'Information';
        data['icon'] = 'fas fa-info-circle';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
    }, (err: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {};
      data['message'] = err.error?.message || 'Error fetching panel data';
      data['title'] = 'Error';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }

  private checkExistingRows(): boolean {
    const panelArray = this.AssignPanelForm.get('panelArray') as FormArray;
    return panelArray.controls.some(ctrl => ctrl.get('EPRDId')?.value);
  }

  populatePanelArray(panelData: any[]) {
  const panelArr = this.AssignPanelForm.get('panelArray') as FormArray;
  panelArr.clear();
  this.teacherTooltips = [];
  this.teacherDetailsList = [];
  this.rowMinDates = [];
  this.rowMaxDates = [];

  panelData.forEach((item) => {
    const displayPanelName = item.PanelNo ? item.PanelNo.toString() : (item.PanelName || '');

    // Parse Teachers JSON and prepare tooltip + details
    let teachersArray: any[] = [];
    let tooltipText = '';
    if (item.Teachers) {
      try {
        teachersArray = typeof item.Teachers === 'string' 
          ? JSON.parse(item.Teachers) 
          : item.Teachers;
        if (Array.isArray(teachersArray) && teachersArray.length) {
          tooltipText = teachersArray.map(t => 
              t.TeacherName + (t.Designation ? ` (${t.Designation})` : '')
          ).join('\n');
        } else {
          tooltipText = 'No teachers assigned';
        }
      } catch (e) {
        console.error('Failed to parse Teachers JSON:', e);
        tooltipText = 'Invalid teacher data';
        teachersArray = [];
      }
    } else {
      tooltipText = 'No teachers assigned';
    }
    this.teacherTooltips.push(tooltipText);
    this.teacherDetailsList.push(teachersArray);

      let minDate: Date | null = null;
      let maxDate: Date | null = null;
      if (item.PtDate && item.PtDate !== '1900-01-01') {
        const parsed = new Date(item.PtDate);
        if (!isNaN(parsed.getTime())) minDate = parsed;
      }
      if (item.PtDateTo && item.PtDateTo !== '1900-01-01') {
        const parsed = new Date(item.PtDateTo);
        if (!isNaN(parsed.getTime())) maxDate = parsed;
      }
      this.rowMinDates.push(minDate);
      this.rowMaxDates.push(maxDate);
    let fromDateValue: Date | string = '';
    if (item.FromDate && item.FromDate !== '1900-01-01') {
      const parsed = new Date(item.FromDate);
      if (!isNaN(parsed.getTime())) fromDateValue = parsed;
    }

    let toDateValue: Date | string = '';
    if (item.ToDate && item.ToDate !== '1900-01-01') {
      const parsed = new Date(item.ToDate);
      if (!isNaN(parsed.getTime())) toDateValue = parsed;
    }

    panelArr.push(this.fb.group({
      EPRDId: [item.EPRDId || item.PanelId],
      PanelNo: [item.PanelNo],
      PanelName: [displayPanelName, Validators.required],
      StdCnt: [item.StdCnt || 0],
      FromDate: [fromDateValue, Validators.required],
      ToDate: [toDateValue, Validators.required]
    }));
  });
  this.cdr.detectChanges();
}
viewTeacherDetails(rowIndex: number) {
  const teachers = this.teacherDetailsList[rowIndex];
  if (!teachers || teachers.length === 0) {
    return;
  }

  // Clean teacher names: replace newlines with spaces
  const teacherList = teachers.map(t => {
    let name = (t.TeacherName || '').replace(/\n/g, ' ').replace(/\r/g, '');
    const desig = t.Designation ? ` (${t.Designation})` : '';
    return `${name}${desig}`;
  }).join('\n');  // use newline, not <br>

  const batchName = this.getBatchDisplayName(rowIndex);
  let data = {
    message: `Teachers for ${batchName}:\n\n${teacherList}`,
    title: 'Teacher Details',
    icon: 'fas fa-users'
  };
  this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
}

private getBatchDisplayName(index: number): string {
  const panelArray = this.AssignPanelForm.get('panelArray') as FormArray;
  const row = panelArray.at(index);
  const panelName = row.get('PanelName')?.value;
  const PanelNo = row.get('PanelNo')?.value;
  return panelName ? `Panel ${panelName}` : (PanelNo ? `Panel ${PanelNo}` : `Row ${index + 1}`);
}

  validateFromDate(index: number) {
    const row = (this.AssignPanelForm.get('panelArray') as FormArray).at(index);
    const dateCtrl = row.get('FromDate') as AbstractControl;
    const selectedDate = dateCtrl.value;
    if (!selectedDate) return;

    const dateObj = new Date(selectedDate);
    // if (dateObj < this.currentDate) {
    //   let data = {};
    //   data['message'] = 'You cannot select a previous date';
    //   data['title'] = 'Invalid Date';
    //   data['icon'] = 'fas fa-close';
    //   this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    //   dateCtrl.setValue('');
    //   return;
    // }
    this.validateDateAgainstHoliday(dateCtrl, dateObj);
  }

 validateToDate(index: number) {
  const row = (this.AssignPanelForm.get('panelArray') as FormArray).at(index);

  const fromDate = row.get('FromDate').value;
  const toDateCtrl = row.get('ToDate') as AbstractControl;
  const toDate = toDateCtrl.value;

  if (!toDate) return;

  // Convert date to date-only (remove time)
  const toDateObj = new Date(toDate);
  const toDateOnly = new Date(
    toDateObj.getFullYear(),
    toDateObj.getMonth(),
    toDateObj.getDate()
  );

  // -----------------------------
  // From Date validation
  // -----------------------------
  if (fromDate) {
    const fromDateObj = new Date(fromDate);

    const fromDateOnly = new Date(
      fromDateObj.getFullYear(),
      fromDateObj.getMonth(),
      fromDateObj.getDate()
    );

    // Same date is allowed
    if (toDateOnly < fromDateOnly) {
      const data = {};
      data['message'] = 'To Date cannot be earlier than From Date';
      data['title'] = 'Invalid Date Range';
      data['icon'] = 'fas fa-close';

      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
        AlertBoxComponent,
        data
      );

      toDateCtrl.setValue('');
      return;
    }
  }

  // -----------------------------
  // Minimum Practical Date
  // -----------------------------
  const minAllowed = this.rowMinDates[index];

  if (minAllowed) {
    const minDateObj = new Date(minAllowed);

    const minDateOnly = new Date(
      minDateObj.getFullYear(),
      minDateObj.getMonth(),
      minDateObj.getDate()
    );

    // Same date as minimum is allowed
    if (toDateOnly < minDateOnly) {
      const formattedMin = this.datePipe.transform(
        minAllowed,
        'dd-MM-yyyy'
      );

      this.showDateError(
        `To Date cannot be earlier than ${formattedMin} (Practical Date range start)`,
        toDateCtrl
      );

      return;
    }
  }

  // -----------------------------
  // Maximum Practical Date
  // -----------------------------
  const maxAllowed = this.rowMaxDates[index];

  if (maxAllowed) {
    const maxDateObj = new Date(maxAllowed);

    const maxDateOnly = new Date(
      maxDateObj.getFullYear(),
      maxDateObj.getMonth(),
      maxDateObj.getDate()
    );

    // Same date as maximum is allowed
    if (toDateOnly > maxDateOnly) {
      const formattedMax = this.datePipe.transform(
        maxAllowed,
        'dd-MM-yyyy'
      );

      this.showDateError(
        `To Date cannot be later than ${formattedMax} (Practical Date range end)`,
        toDateCtrl
      );

      return;
    }
  }

  // -----------------------------
  // Holiday validation
  // -----------------------------
  this.validateDateAgainstHoliday(toDateCtrl, toDateObj);
}

  private showDateError(message: string, control: AbstractControl) {
    let data = {};
    data['message'] = message;
    data['title'] = 'Invalid Date';
    data['icon'] = 'fas fa-close';
    this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    control.setValue('');
  }

  validateDateAgainstHoliday(control: AbstractControl, date: Date) {
    const dateTime = date.getTime();
    const isHoliday = this.holidayDates.some(holiday => {
      const from = new Date(holiday.FromDate).setHours(0, 0, 0, 0);
      const to = new Date(holiday.ToDate).setHours(23, 59, 59, 999);
      return dateTime >= from && dateTime <= to;
    });
    if (isHoliday) {
      const holidayNames = this.holidayDates.filter(holiday => {
        const from = new Date(holiday.FromDate).setHours(0, 0, 0, 0);
        const to = new Date(holiday.ToDate).setHours(23, 59, 59, 999);
        return dateTime >= from && dateTime <= to;
      }).map(h => h.HolidayName).join(', ');
      let confirmData = {};
      confirmData['message'] = `Selected date falls on holiday: ${holidayNames}. Do you still want to proceed?`;
      confirmData['title'] = 'Holiday Alert';
      confirmData['icon'] = 'fa fa-question';
      const confirmDialog = this.modalPopupService.openPopup(ConformationModelComponent, confirmData);
      confirmDialog.afterClosed().subscribe(result => {
        if (result !== 'yes') control.setValue('');
      });
    }
  }

  dateClass = (d: Date | null): string => {
    if (!d) return '';
    const date = new Date(d);
    date.setHours(0, 0, 0, 0);
    const isHoliday = this.holidayDates.some(holiday => {
      const from = new Date(holiday.FromDate).setHours(0, 0, 0, 0);
      const to = new Date(holiday.ToDate).setHours(23, 59, 59, 999);
      return date.getTime() >= from && date.getTime() <= to;
    });
    return isHoliday ? 'holiday-date' : '';
  };

  fetchHolidays() {
    this.umsService.getExamHoliday({ SnNo: '' }).subscribe(res => {
      if (res.status) {
        this.holidayDates = res.data.map(item => ({
          FromDate: new Date(item.FromDate),
          ToDate: new Date(item.ToDate),
          HolidayName: item.HolidayName
        }));
        this.cdr.detectChanges();
      } else {
        this.holidayDates = [];
      }
    });
  }

  
  async onSave() {
    if (this.AssignPanelForm.invalid) {
      this.AssignPanelForm.markAllAsTouched();
      (this.AssignPanelForm.get('panelArray') as FormArray).controls.forEach(ctrl => {
        ctrl.get('FromDate')?.markAsTouched();
        ctrl.get('ToDate')?.markAsTouched();
      });
      return;
    }

    const panelArray = this.AssignPanelForm.get('panelArray') as FormArray;
    const newRows = panelArray.controls.filter(ctrl => !ctrl.get('EPRDId')?.value);

    if (newRows.length === 0) {
      let data = {};
      data['message'] = 'No new batches to save';
      data['title'] = 'Information';
      data['icon'] = 'fas fa-info-circle';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      return;
    }

    this.isBtnDisabled = true;
    this.spinner.show();

    let successCount = 0;
    let errorMsg = '';

    for (const row of newRows) {
      const payload = this.buildBatchPayload(row);
      try {
        const res: any = await this.umsService.addPanelBatch(payload).toPromise();
        if (res && res.status) successCount++;
        else errorMsg = res?.message || 'Error saving batch';
      } catch (err) {
        errorMsg = err.error?.message || 'Network error';
        break;
      }
    }

    this.spinner.hide();
    this.isBtnDisabled = false;

    if (successCount === newRows.length) {
      let data = {};
      data['message'] = 'All new batches added successfully';
      data['title'] = 'Success';
      data['icon'] = 'fas fa-check';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.showUpdateBtn = true;
      this.showSaveBtn = false;
      this.onShowData();
    } else {
      let data = {};
      data['message'] = errorMsg || 'Some batches failed to save. Please try again.';
      data['title'] = 'Partial Error';
      data['icon'] = 'fas fa-exclamation-triangle';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    }
  }


  async onUpdate() {
    if (this.AssignPanelForm.invalid) {
      this.AssignPanelForm.markAllAsTouched();
      (this.AssignPanelForm.get('panelArray') as FormArray).controls.forEach(ctrl => {
        ctrl.get('FromDate')?.markAsTouched();
        ctrl.get('ToDate')?.markAsTouched();
      });
      return;
    }

    const panelArray = this.AssignPanelForm.get('panelArray') as FormArray;
    const existingRows = panelArray.controls.filter(ctrl => ctrl.get('EPRDId')?.value);

    if (existingRows.length === 0) {
      let data = {};
      data['message'] = 'No existing batches to update';
      data['title'] = 'Information';
      data['icon'] = 'fas fa-info-circle';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      return;
    }

    this.isBtnDisabled = true;
    this.spinner.show();

    let successCount = 0;
    let errorMsg = '';

    for (const row of existingRows) {
      const payload = this.buildBatchPayload(row);
      try {
        const res: any = await this.umsService.updatePanelBatch(payload).toPromise();
        if (res && res.status) successCount++;
        else errorMsg = res?.message || 'Error updating batch';
      } catch (err) {
        errorMsg = err.error?.message || 'Network error';
        break;
      }
    }

    this.spinner.hide();
    this.isBtnDisabled = false;

    if (successCount === existingRows.length) {
      let data = {};
      data['message'] = 'All Panel Scheduled successfully.';
      data['title'] = 'Success';
      data['icon'] = 'fas fa-check';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.onShowData();
    } else {
      let data = {};
      data['message'] = errorMsg || 'Some updates failed. Please try again.';
      data['title'] = 'Error';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    }
  }

  deleteBatch(index: number) {
    const row = (this.AssignPanelForm.get('panelArray') as FormArray).at(index);
    const eprdId = row.get('EPRDId')?.value;
    if (!eprdId) {
      (this.AssignPanelForm.get('panelArray') as FormArray).removeAt(index);
      return;
    }

    let confirmData = {};
    confirmData['message'] = 'Are you sure you want to delete this batch?';
    confirmData['title'] = 'Confirm Delete';
    confirmData['icon'] = 'fa fa-question';
    const confirmDialog = this.modalPopupService.openPopup(ConformationModelComponent, confirmData);
    confirmDialog.afterClosed().subscribe(result => {
      if (result === 'yes') {
        this.spinner.show();
        const payload = this.buildBatchPayload(row);
        this.umsService.deletePanelBatch(payload).subscribe(res => {
          this.spinner.hide();
          if (res.status) {
            (this.AssignPanelForm.get('panelArray') as FormArray).removeAt(index);
            let data = {};
            data['message'] = 'Batch deleted successfully';
            data['title'] = 'Success';
            data['icon'] = 'fas fa-check';
            this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          } else {
            let data = {};
            data['message'] = res.message || 'Deletion failed';
            data['title'] = 'Error';
            data['icon'] = 'fas fa-close';
            this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          }
        });
      }
    });
  }

  
  private buildBatchPayload(rowCtrl: AbstractControl): any {
    const mainForm = this.AssignPanelForm.value;
    const rowValue = rowCtrl.value;
    return {
      EPRDId: rowValue.EPRDId || 0,
      CgCode: mainForm.CgCode,
      SubId: mainForm.EsId,
      EmId: mainForm.EmId,
      CoCode: mainForm.CoCode,
      SessionNo: mainForm.SessionId,
      PanelNo: rowValue.PanelNo || parseInt(rowValue.PanelName, 10) || 0,
      StdCnt: rowValue.StdCnt || 0,
      FromDate: rowValue.FromDate ? this.datePipe.transform(rowValue.FromDate, 'yyyy-MM-dd') : null,
      ToDate: rowValue.ToDate ? this.datePipe.transform(rowValue.ToDate, 'yyyy-MM-dd') : null
    };
  }

  onCancel() {
    this.AssignPanelForm.reset();
    (this.AssignPanelForm.get('panelArray') as FormArray).clear();
    this.showTable = false;
    this.showSaveBtn = true;
    this.showUpdateBtn = false;
    this.showBranch = false;
    this.courseList = [];
    this.courseFilterList = [];
    this.examList = [];
    this.examFilterList = [];
    this.collegeList = [];
    this.centerFilterList = [];
    this.branchList = [];
    this.branchFilterList = [];
    this.subjectList = [];
    this.subjectFilterList = [];
  }

  private resetFormAfterSession() {
    this.AssignPanelForm.patchValue({ CoCode: '', EmId: '', strId: '', CgCode: '', EsId: '' });
    this.showTable = false;
    this.showBranch = false;
    this.courseList = [];
    this.courseFilterList = [];
    this.examList = [];
    this.examFilterList = [];
    this.collegeList = [];
    this.centerFilterList = [];
    this.branchList = [];
    this.branchFilterList = [];
    this.subjectList = [];
    this.subjectFilterList = [];
  }

  private clearExamAndCenter() {
    this.AssignPanelForm.patchValue({ EmId: '', strId: '', CgCode: '', EsId: '' });
    this.examList = [];
    this.examFilterList = [];
    this.collegeList = [];
    this.centerFilterList = [];
    this.showBranch = false;
    this.subjectList = [];
    this.subjectFilterList = [];
  }

  private clearBranchAndCenter() {
    this.AssignPanelForm.patchValue({ strId: '', CgCode: '', EsId: '' });
    this.collegeList = [];
    this.centerFilterList = [];
    this.subjectList = [];
    this.subjectFilterList = [];
  }
}